module.exports = __webpack_public_path__ + "static/media/submission.cdc8bcd5.svg";